import { render } from "./user-system-feature-settings.vue?vue&type=template&id=68ac47f5"
import script from "./user-system-feature-settings.vue?vue&type=script&lang=js"
export * from "./user-system-feature-settings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__